import type CardLocation from '@alltrails/amplitude/enums/CardLocation';

export const tripPlannerEntryPointParamKey = 'entryPoint';
export const tripPlannerEntryLocationIdParamKey = 'entryLocationId';
export const tripPlannerEntryParkIdParamKey = 'entryParkId';

export type TripPlannerEntryPoint = Extract<
  CardLocation,
  | 'explore side bar'
  | 'location page'
  | 'park page'
  | 'poi page'
  | 'search result'
  | 'web explore nav menu'
  | 'web homepage button group below search bar'
>;

const tripPlannerEntryPoints: readonly TripPlannerEntryPoint[] = [
  'explore side bar',
  'location page',
  'park page',
  'poi page',
  'search result',
  'web explore nav menu',
  'web homepage button group below search bar'
];

export type TripPlannerEntryContext = {
  entryPoint?: TripPlannerEntryPoint;
  locationId?: number;
  parkId?: number;
};

export const getTripPlannerEntryParams = ({ entryPoint, locationId, parkId }: TripPlannerEntryContext): Record<string, string> => ({
  ...(entryPoint ? { [tripPlannerEntryPointParamKey]: entryPoint } : {}),
  ...(locationId === undefined ? {} : { [tripPlannerEntryLocationIdParamKey]: String(locationId) }),
  ...(parkId === undefined ? {} : { [tripPlannerEntryParkIdParamKey]: String(parkId) })
});

const parseId = (value?: string | null) => {
  if (!value) {
    return undefined;
  }
  const id = Number(value);
  return Number.isFinite(id) ? id : undefined;
};

export const parseTripPlannerEntryContext = (getParam: (key: string) => string | null | undefined): TripPlannerEntryContext => {
  const rawEntryPoint = getParam(tripPlannerEntryPointParamKey);
  return {
    entryPoint: tripPlannerEntryPoints.find(entryPoint => entryPoint === rawEntryPoint),
    locationId: parseId(getParam(tripPlannerEntryLocationIdParamKey)),
    parkId: parseId(getParam(tripPlannerEntryParkIdParamKey))
  };
};
